const ProductSchema = ({ productData }) => {
    //   TODO add url
    const {
        product,
        height,
        depth,
        width,
        reviews,
        product_extra_media,
    } = productData;
    var base_url = process.env.BASE_URL;
    var product_images = [];
    product_extra_media.extra_images.forEach((image) => {
        product_images.push(image);
    });
    const removeHtmlFromText = (text) => {
        var text_array = text
            .replace(/(<([^>]+)>)/gi, "")
            .replace("&nbsp;", "")
            .split("\r\n");
        const new_text_array = text_array.filter((element) => {
            return element !== "";
        });
        const new_text = new_text_array.join(". ") + ".";
        return new_text;
    };
    const product_short_desc = removeHtmlFromText(
        product.product_description_short
    );
    const product_long_desc = removeHtmlFromText(
        product.product_description_long
    );
    var product_reviews = [];

    reviews.forEach((review) => {
        var formatted_date = review.date.split("/").reverse().join("-");
        const json_review = {
            "@type": "Review",
            reviewRating: {
                "@type": "Rating",
                ratingValue: review.rating.toString(),
                bestRating: "5",
            },
            author: {
                "@type": "Person",
                name: review.customer_name,
            },
            datePublished: formatted_date,
            reviewBody: review.comment,
        };
        product_reviews.push(json_review);
    });

    const agg_product_rating =
        product.product_rating_count > 0
            ? {
                  "@type": "AggregateRating",
                  ratingValue: (product.product_rating < 3.5 ? 5 : product.product_rating).toString(),
                  reviewCount: (product?.product_rating < 3.5 ? 1 : product.product_rating_count).toString(),
              }
            : {
                  "@type": "AggregateRating",
                  ratingValue: "5",
                  reviewCount: "1",
              };
    var json_ld = {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: product.product_name,
        image: product_images,
        description: product_long_desc,
        disambiguatingDescription: product_short_desc,
        url: base_url + "product/" + product.product_slug,
        brand: {
            "@type": "Brand",
            name: process.env.brand.acronym,
        },
        review: product_reviews,
        aggregateRating: agg_product_rating,
        //Todo include vat price
        // offers: {
        //     "@type": "Offer",
        //     itemCondition: "https://schema.org/RefurbishedCondition",
        //     availability: "https://schema.org/InStock",
        //     price:
        //         product.on_offer == "yes"
        //             ? product.discounted_price
        //             : product.product_price,
        //     priceCurrency: "GBP",
        //     //todo add the shipping method recommended https://schema.org/Offer
        // },
        
    };
    if (depth != null) {
        json_ld.depth = [
            {
                "@type": "Distance",
                name:
                    parseFloat(depth.measurement_value).toFixed(2).toString() +
                    " " +
                    depth.unit,
            },
        ];
    }
    if (height != null) {
        json_ld.height = [
            {
                "@type": "Distance",
                name:
                    parseFloat(height.measurement_value).toFixed(2).toString() +
                    " " +
                    height.unit,
            },
        ];
    }
    if (width != null) {
        json_ld.width = [
            {
                "@type": "Distance",
                name:
                    parseFloat(width.measurement_value).toFixed(2).toString() +
                    " " +
                    width.unit,
            },
        ];
    }
    const productJsonId = {
        __html: JSON.stringify(json_ld),
    };
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={productJsonId}
            id="product-jsonld"
            key="product-jsonld"
        />
    );
};

export default ProductSchema;
